import React, { useEffect, useMemo, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import {
  FORM_FIELDS_NAME,
  YesNoDrop,
  afterHourFeeStatusDrop,
  airportChargeStatusDrop,
  concessionFeeTypeDrop,
  editMode,
  hourslist,
  policyBreakdownlist,
  statusDrop,
} from "./constant";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Col, Row } from "react-bootstrap";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import EzControlledCheckBoxWithLabel from "../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { goBack } from "../../../utils/gotoback";
import { loadingShow } from "../../../services/PostAPI";
import Breadcrumb from "../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  basicDetail,
  hoursSetting,
  freesCharges,
  locationExtraHoursSetting,
  locationPolicyRules,
  POLICY_MAX_LENGTH,
  breakdownFieldRules,
  BREAKDOWN_FIELD_MAX_LENGTH,
} from "../CreateLocation/constant";
import {
  Box,
  Container,
  Grid,
  Step,
  StepButton,
  Stepper,
  Typography,
} from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledInputAreaWithFloatingLabel from "../../../common/EzForm/EzControlledInputArea/WithFloatingLabel";
import EzControlledEditorFloatingLabel from "../../../common/EzForm/EzControlledEditor/WithFloatingLabel";
import EzControlledCalendarWithFloatingLabel from "../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import EzControlledCheckBox from "../../../common/EzForm/EzControlledCheckBox";
import EzDialog from "../../../common/EzDialog";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
const steps = [
  "Basic Details",
  "Hours Settings",
  "Fees/Charges",
  "Vehicle Categories",
  "Extra Products",
  "Policy & Shuttle Hours",
];

const CreateLocationComponent = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateLocationScreen,
    createLocation,
    editLocation,
    fetchCategory,
    isLoading,
    isCreateSuccess,
    isCreateError,
    isDetailSuccess,
    isDetailError,
    isEditSuccess,
    isEdit,
    isCopy,
    isView,
    formFieldValueMap,
    extraProductList,
    shouldBlockNavigation,
    categoryListview,
  } = props;
  console.log("check props of compoemnt", props);

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
  } = useForm({
    shouldFocusError: false,
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });

  const locationName = watch("locationName");
  const address = watch("address");
  const pin = watch("pin");
  const contact = watch("contact");
  const country = watch("country");
  const breadcrumbD = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/location", label: "Location" },
    { path: "#", label: locationName },
  ];
  const anyAirportLocation = watch("anyAirportLocation");
  const status = watch("status");
  const [showDialog, setShowDialog] = useState(false);
  const [vehicleCategory, setVehicleCategory] = React.useState([]);
  const [selectedExtraProducts, setSelectedExtraProducts] = useState([]);
  const [applyMondayToAll, setApplyMondayToAll] = useState(false);

  const monStartHour = watch("monStartHour");
  const monEndHour = watch("monEndHour");
  const monAfterHourEnd = watch("monAfterHourEnd");
  const monAfterHourDropoff24h = watch("monAfterHourDropoff24h");

  const handleApplyMondayToAll = (e) => {
    const checked = e.target.checked;
    setApplyMondayToAll(checked);

    if (checked && monStartHour && monEndHour && monAfterHourEnd) {
      const days = ["tue", "wed", "thu", "fri", "sat", "sun"];
      days.forEach((day) => {
        setValue(`${day}StartHour`, monStartHour);
        setValue(`${day}EndHour`, monEndHour);
        setValue(`${day}AfterHourEnd`, monAfterHourEnd);
        setValue(`${day}AfterHourDropoff24h`, monAfterHourDropoff24h || false);
      });
    }
  };
  // Step code
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState(false);
  const [isCatogary, setIsCatogary] = useState(false);

  const { fields, append, update } = useFieldArray({
    control,
    name: "locationExtraHourRequests",
  });
  const watchFieldArray = watch("locationExtraHourRequests");
  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  const handleRemoveClick = (i) => {
    const updatedData = controlledFields.map((item, index) =>
      i === index ? { ...item, status: false } : { ...item },
    );
    update(i, { status: false, ...updatedData[i] });
  };

  //Adding Item
  const handleAddClick = () => {
    append({
      id: 0,
      status: true,
      startDate: "",
      endDate: "",
      startHour: "",
      endHour: "",
      afterEndHour: "",
    });
  };

  const renderstartHour = (index, id) => {
    const starthours = errors?.locationExtraHourRequests?.[index]?.startHour;
    return (
      <EzControlledDropDowntWithFloatingLabel
        id={id}
        name={`locationExtraHourRequests.${index}.startHour`}
        control={control}
        rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
        optionLabel={"name"}
        optionValue={"id"}
        options={hourslist}
        isError={starthours}
        errorMsg={getFormErrorMessage(starthours)}
        label={"Start Hour"}
        labelClassName={"ml-2"}
      />
    );
  };
  const renderendHour = (index, id) => {
    const endHour = errors?.locationExtraHourRequests?.[index]?.endHour;
    return (
      <EzControlledDropDowntWithFloatingLabel
        id={id}
        name={`locationExtraHourRequests.${index}.endHour`}
        control={control}
        rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
        optionLabel={"name"}
        optionValue={"id"}
        options={hourslist}
        isError={endHour}
        errorMsg={getFormErrorMessage(endHour)}
        label={"End Hour"}
        labelClassName={"ml-2"}
      />
    );
  };

  const renderafterEndHour = (index, id) => {
    const afterEndHour =
      errors?.locationExtraHourRequests?.[index]?.afterEndHour;
    return (
      <EzControlledDropDowntWithFloatingLabel
        id={id}
        name={`locationExtraHourRequests.${index}.afterEndHour`}
        control={control}
        rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
        optionLabel={"name"}
        optionValue={"id"}
        options={hourslist}
        isError={afterEndHour}
        errorMsg={getFormErrorMessage(afterEndHour)}
        label={"After End Hour"}
        labelClassName={"ml-2"}
      />
    );
  };
  const renderstartDate = (index, id) => {
    const DDstartDate = errors?.locationExtraHourRequests?.[index]?.startDate;
    return (
      <EzControlledCalendarWithFloatingLabel
        id={id}
        name={`locationExtraHourRequests.${index}.startDate`}
        {...register(`locationExtraHourRequests.${index}.startDate`)}
        showTime={false}
        maxDate={new Date(2090, 0, 1)}
        control={control}
        isError={DDstartDate}
        errorMsg={getFormErrorMessage(DDstartDate)}
        label={"Start Date"}
        rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
      />
    );
  };
  const renderendDate = (index, id) => {
    const EEendDate = errors?.locationExtraHourRequests?.[index]?.endDate;
    return (
      <EzControlledCalendarWithFloatingLabel
        id={id}
        name={`locationExtraHourRequests.${index}.endDate`}
        {...register(`locationExtraHourRequests.${index}.endDate`)}
        showTime={false}
        maxDate={new Date(2090, 0, 1)}
        control={control}
        isError={EEendDate}
        errorMsg={getFormErrorMessage(EEendDate)}
        label={"End Date"}
        rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
      />
    );
  };
  const navigateToLocationScreen = () => {
    navigate(APP_URLS.LOCATION.HOME);
  };
  const onDialogHide = () => {
    setShowDialog(false);
  };
  const policyBrakdownModal = () => {
    setShowDialog(true);
  };
  const totalSteps = () => {
    return steps.length - 1;
  };

  useEffect(() => {
    if (!isCreateSuccess && !isEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isCreateSuccess, isEditSuccess]);

  useEffect(() => {
    if (isCreateSuccess) {
      reset();
    }
  }, [isCreateSuccess]);

  // legacy markChecked removed; using buildCategoryRows + hydrateCategoryRows
  useEffect(() => {
    setTimeout(() => setIsCatogary(false), 1000);
  }, [isCatogary]);
  // legacy category mapping/hydration removed in favor of the helpers below

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setCompleted(false);
    setVehicleCategory((prevItems) =>
      (prevItems || []).map((item) =>
        item.name === name ? { ...item, checked, value: checked } : item,
      ),
    );
  };

  const handleMileageCheckbox = (e) => {
    const { name, checked } = e.target; // name like unlimitedMileage_{id}
    setVehicleCategory((prevItems) =>
      (prevItems || []).map((item) =>
        item.mileageField === name
          ? { ...item, unlimitedMileage: checked }
          : item,
      ),
    );
  };

  useEffect(() => {
    const rows =
      Array.isArray(categoryListview) && categoryListview.length > 0
        ? buildCategoryRows(categoryListview)
        : [];
    setVehicleCategory(rows);
  }, [categoryListview]);

  useEffect(() => {
    if (isDetailSuccess) {
      const { categoryId = [] } = formFieldValueMap || {};
      const base = buildCategoryRows(categoryListview || []);
      const hydrated = hydrateCategoryRows(base, categoryId);
      setVehicleCategory(hydrated);
      reset({ ...formFieldValueMap });
    }
  }, [isDetailSuccess, categoryListview]);

  useEffect(() => {
    if (isEdit && isDetailSuccess && formFieldValueMap?.extraProductChargeId) {
      setSelectedExtraProducts(formFieldValueMap.extraProductChargeId);
    }
  }, [isDetailSuccess, formFieldValueMap]);

  const handleExtraProductCheck = (id) => {
    setSelectedExtraProducts((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

  const buildCategoryRows = (list = []) =>
    list.map((item) => ({
      name: "category_" + item.id,
      value: false,
      id: item.id,
      title: item.title,
      unlimitedMileage: false,
      mileageField: "unlimitedMileage_" + item.id,
    }));

  const hydrateCategoryRows = (rows = [], catObjs = []) => {
    const selectedIds = (catObjs || []).map((o) => o.categoryId);
    const unlimitedIds = (catObjs || [])
      .filter((o) => Number(o.unlimitedMileage) === 1)
      .map((o) => o.categoryId);

    return (rows || []).map((r) => {
      const isSelected = selectedIds.includes(r.id);
      const isUnlimited = unlimitedIds.includes(r.id);
      return {
        ...r,
        checked: isSelected,
        value: isSelected,
        unlimitedMileage: isUnlimited,
      };
    });
  };


  const step0RequiredFields = [
    "locationName", "address", "pin", "contact", "anyAirportLocation", 
    "status", "prefixId", "reservationEmailTo", "reservationEmailBcc", "reservationPageText"
  ];
  
  const step1RequiredFields = [
    "monStartHour", "monEndHour", "monAfterHourEnd",
    "tueStartHour", "tueEndHour", "tueAfterHourEnd",
    "wedStartHour", "wedEndHour", "wedAfterHourEnd",
    "thuStartHour", "thuEndHour", "thuAfterHourEnd",
    "friStartHour", "friEndHour", "friAfterHourEnd",
    "satStartHour", "satEndHour", "satAfterHourEnd",
    "sunStartHour", "sunEndHour", "sunAfterHourEnd"
  ];
  
  const step2RequiredFields = [
    "taxPercent", "afterHourFeeStatus", "afterHourDropoff", "energyRecoveryFee",
    "maintenanceFee", "vehicleLicenseFee", "roadSideService", "airportFacilityCharge",
    "airportFacilityChargeMaxDays", "concessionFeeType", "airportConcessionFeeRate",
    "underageRate", "airportChargeStatus", "surcharge", "dailyRentalFee"
  ];

  const handleNext = async () => {
    const checkedObjects = vehicleCategory.filter((obj) => obj.checked);
    const objlen = checkedObjects.length;
    const newActiveStep = activeStep + 1;
    
    if (activeStep === 0) {
      const isValid = await trigger(step0RequiredFields);
      if (!isValid) return;
    } else if (activeStep === 1) {
      const isValid = await trigger(step1RequiredFields);
      if (!isValid) return;
    } else if (activeStep === 2) {
      const isValid = await trigger(step2RequiredFields);
      if (!isValid) return;
    } else if (activeStep === 3 && objlen <= 0) {
      return setIsCatogary(true);
    } else if (activeStep === 5) {
      const length = Object.keys(errors).length;
      if (length > 0) return;
    }
    
    if (totalSteps() === newActiveStep) {
      setCompleted(true);
    }

    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    if (activeStep - 1 != totalSteps()) {
      setCompleted(false);
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => async () => {
    if (isEdit === true) {
      if (step > activeStep) {
        for (let i = activeStep; i < step; i++) {
          if (i === 0) {
            const isValid = await trigger(step0RequiredFields);
            if (!isValid) return;
          } else if (i === 1) {
            const isValid = await trigger(step1RequiredFields);
            if (!isValid) return;
          } else if (i === 2) {
            const isValid = await trigger(step2RequiredFields);
            if (!isValid) return;
          } else if (i === 3) {
            const checkedObjects = vehicleCategory.filter((obj) => obj.checked);
            if (checkedObjects.length <= 0) {
              setIsCatogary(true);
              return;
            }
          }
        }
      }
      
      if (step != totalSteps()) {
        setCompleted(false);
      } else {
        setCompleted(true);
      }
      setActiveStep(step);
    }
  };

  const getToastProps = () => {
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: isCatogary,
    };
  };

  //End Step code

  const removeKeysWithWord = (obj, word) => {
    let result = {};
    for (let key in obj) {
      if (!key.toLowerCase().includes(word.toLowerCase())) {
        result[key] = obj[key];
      }
    }
    return result;
  };
  const onSubmit = (data) => {
    let locationExtraHourRequests = data?.locationExtraHourRequests || [];
    locationExtraHourRequests = locationExtraHourRequests.filter(
      (item) => item.status !== false,
    );

    let newData = removeKeysWithWord(data, "category_");
    newData = removeKeysWithWord(newData, "unlimitedMileage_");
    newData = removeKeysWithWord(newData, "extraProduct_");

    // Build category payload
    const categoryPayload = (vehicleCategory || [])
      .filter((item) => item.checked === true)
      .map((item) => ({
        categoryId: item.id,
        unlimitedMileage: item.unlimitedMileage ? 1 : 0,
      }));

    newData["userId"] = localStorage.getItem("userId");
    newData.extraProductChargeId = selectedExtraProducts;

    const stringifiedData = {
      ...newData,
      id: (isEdit && !isCopy) ? data?.id : null,
      categoryId: categoryPayload,
      locationExtraHourRequests,
      extraProductChargeId: selectedExtraProducts,
      monIsClosed: newData.monIsClosed ? 1 : 0,
      tueIsClosed: newData.tueIsClosed ? 1 : 0,
      wedIsClosed: newData.wedIsClosed ? 1 : 0,
      thuIsClosed: newData.thuIsClosed ? 1 : 0,
      friIsClosed: newData.friIsClosed ? 1 : 0,
      satIsClosed: newData.satIsClosed ? 1 : 0,
      sunIsClosed: newData.sunIsClosed ? 1 : 0,
    };

    // API call: create or update
    if (activeStep === 5) {
      (isEdit && !isCopy)
        ? editLocation({ id: data.id, data: stringifiedData })
        : createLocation(stringifiedData);
    }
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error" style={{ fontSize: "11px" }}>{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">
              {isEdit && !isCopy ? "Update Location" : isCopy ? "Copy Location" : "Create Location"}
            </h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Location"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Location"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToLocationScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={breadcrumbD} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Stepper
              className={classes.mainstep}
              nonLinear
              activeStep={activeStep}
            >
              {steps.map((label, index) => (
                <Step key={label} completed={completed[index]}>
                  <StepButton
                    active="ac"
                    color="inherit"
                    onClick={handleStep(index)}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
            {activeStep === 0 && (
              <Grid container spacing={2}>
                {basicDetail?.map((item) =>
                  item.name === "anyAirportLocation" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={YesNoDrop}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "status" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={statusDrop}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "weekHourStart" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={hourslist}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "weekHourEnd" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={hourslist}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "weekEndHourStart" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={hourslist}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "weekEndHourEnd" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={hourslist}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "reservationPageText" ? (
                    <Grid item xs={12} sm={6} md={4} lg={6} key={item.name}>
                      <EzControlledInputAreaWithFloatingLabel
                        name={item?.name}
                        control={control}
                        label={item?.label}
                        rules={item?.rule}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledInputWithFloatingLabel
                        name={item?.name}
                        control={control}
                        label={item?.label}
                        rules={item?.rule}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                      />
                    </Grid>
                  ),
                )}
              </Grid>
            )}

            {activeStep === 1 && (
              <Grid container spacing={2}>
                {monStartHour && monEndHour && monAfterHourEnd && (
                  <Grid item xs={12} mb={2}>
                    <Box display="flex" alignItems="center">
                      <EzControlledCheckBoxWithLabel
                        name="applyMondayToAll"
                        value={applyMondayToAll}
                        id="applyMondayToAll"
                        control={control}
                        label="Apply Monday hours to all days"
                        labelClassName={"ml-2"}
                        onChange={handleApplyMondayToAll}
                      />
                    </Box>
                  </Grid>
                )}

                {/* Monday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Monday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index < 3 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="monAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="monIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Tuesday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Tuesday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index > 2 && index < 6 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="tueAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="tueIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"} 
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Wednesday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Wednesday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index > 5 && index < 9 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="wedAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="wedIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Thursday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Thursday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index > 8 && index < 12 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="thuAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="thuIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Friday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Friday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index > 11 && index < 15 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="friAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="friIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Saturday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Saturday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index > 14 && index < 18 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="satAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="satIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Sunday */}
                <Grid item xs={12}>
                  <Box className="hours-day-block">
                  <Typography className="hours-day-title" fontWeight={"bold"} mb={2}>Sunday</Typography>
                  <Grid container spacing={2}>
                    {hoursSetting?.map(
                      (item, index) =>
                        index > 17 && index < 21 && (
                          <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <EzControlledDropDowntWithFloatingLabel
                              name={item?.name}
                              control={control}
                              rules={item?.rule}
                              optionLabel={"name"}
                              optionValue={"id"}
                              options={hourslist}
                              isError={errors[item?.name]}
                              errorMsg={getFormErrorMessage(item?.name)}
                              label={item?.label}
                              labelClassName={"ml-2"}
                            />
                          </Grid>
                        ),
                    )}
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="sunAfterHourDropoff24h"
                        control={control}
                        label="24h Dropoff"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} sx={{ flexBasis: { md: '12.5%' }, maxWidth: { md: '12.5%' } }}>
                      <EzControlledCheckBoxWithLabel
                        name="sunIsClosed"
                        control={control}
                        label="Is Closed"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  </Grid>
                  </Box>
                </Grid>

                {/* Lead Time */}
                <Grid item xs={12} sm={6} md={3}>
                  {hoursSetting?.map(
                    (item, index) =>
                      index === 35 && (
                        <EzControlledInputWithFloatingLabel
                          key={item.name}
                          name={item?.name}
                          control={control}
                          rules={item?.rule}
                          type="number"
                          isError={errors[item?.name]}
                          errorMsg={getFormErrorMessage(item?.name)}
                          label={item?.label}
                        />
                      ),
                  )}
                </Grid>

                {/* Extra Hour Settings */}
                <Grid item xs={12}>
                  <Box
                    className="addition"
                    sx={{ xs: 12, md: 6, lg: 4 }}
                    mt={2}
                  >
                    <Typography>Extra Hour Settings</Typography>
                    <div
                      style={{ margin: "0px", maxWidth: "70px" }}
                      className="addbtn"
                    >
                      <Button
                        icon={"pi pi-plus"}
                        type="button"
                        onClick={handleAddClick}
                        className="mt-2 p-button-raised"
                      />
                    </div>
                  </Box>
                  <Grid container marginTop={"30px"}>
                    {controlledFields.map((field, index) => {
                      return field.status !== false ? (
                        <Grid
                          container
                          spacing={2}
                          key={`item${index}`}
                          marginTop={"20px"}
                        >
                          <Grid
                            className={classes.pt0}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                          >
                            {renderstartDate(index, field.id)}
                          </Grid>
                          <Grid
                            className={classes.pt0}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                          >
                            {renderendDate(index, field.id)}
                          </Grid>
                          <Grid
                            className={classes.pt0}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                          >
                            {renderstartHour(index, field.id)}
                          </Grid>
                          <Grid
                            className={classes.pt0}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                          >
                            {renderendHour(index, field.id)}
                          </Grid>
                          <Grid
                            className={classes.pt0}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                          >
                            {renderafterEndHour(index, field.id)}
                          </Grid>
                          <Grid
                            className={classes.pt0}
                            item
                            xs={12}
                            sm={2}
                            md={4}
                            lg={3}
                            display={"flex"}
                          >
                            <div
                              style={{
                                margin: "0px 0px 0px 10px",
                                maxWidth: "70px",
                              }}
                            >
                              <Button
                                icon={"pi pi-minus"}
                                type="button"
                                onClick={() => handleRemoveClick(index)}
                                className="p-button-raised"
                              />
                            </div>
                          </Grid>
                        </Grid>
                      ) : null;
                    })}
                  </Grid>
                </Grid>
              </Grid>
            )}

            {activeStep === 2 && (
              <Grid container spacing={2}>
                {freesCharges?.map((item) =>
                  item.name === "afterHourFeeStatus" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={afterHourFeeStatusDrop}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "afterHourDropoff" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={airportChargeStatusDrop}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "concessionFeeType" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={concessionFeeTypeDrop}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : item.name === "airportChargeStatus" ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledDropDowntWithFloatingLabel
                        name={item?.name}
                        control={control}
                        rules={item?.rule}
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={airportChargeStatusDrop}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                        label={item?.label}
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                      <EzControlledInputWithFloatingLabel
                        name={item?.name}
                        control={control}
                        label={item?.label}
                        rules={item?.rule}
                        isError={errors[item?.name]}
                        errorMsg={getFormErrorMessage(item?.name)}
                      />
                    </Grid>
                  ),
                )}
              </Grid>
            )}

            {activeStep === 3 && (
              <div className="vcTable">
                <Grid container spacing={0}>
                  <Grid item xs={6} className="vcHeaderCell vcDivider">
                    Category Name
                  </Grid>
                  <Grid item xs={6} className="vcHeaderCell">
                    Mileage Option
                  </Grid>

                  {vehicleCategory.length > 0 &&
                    vehicleCategory.map((item, idx) => (
                      <React.Fragment key={item.id}>
                        <Grid item xs={6} className="vcCell vcDivider">
                          <EzControlledCheckBoxWithLabel
                            name={item.name}
                            value={item.value}
                            id={item.name}
                            control={control}
                            isError={errors[item.title]}
                            label={item.title}
                            labelClassName={"ml-2"}
                            onChange={handleCheckbox}
                          />
                        </Grid>
                        <Grid item xs={6} className="vcCell">
                          <EzControlledCheckBoxWithLabel
                            name={item.mileageField}
                            value={item.unlimitedMileage}
                            id={item.mileageField}
                            control={control}
                            label={"Unlimited Mileage"}
                            labelClassName={"ml-2"}
                            onChange={handleMileageCheckbox}
                            disabled={!item.value}
                          />
                        </Grid>
                      </React.Fragment>
                    ))}
                </Grid>
              </div>
            )}

            {activeStep === 4 && (
              <div className="table-responsive">
                <div className="extraProductTable">
                  <Grid container className="extraProductHeader">
                    <Grid item xs={3} className="extraProductCell vcDivider">
                      Extra Product Charge
                    </Grid>
                    <Grid item xs={3} className="extraProductCell vcDivider">
                      Extra Product Category
                    </Grid>
                    <Grid item xs={6} className="extraProductCell">
                      Vehicle Category Being Applied To
                    </Grid>
                  </Grid>
                  {extraProductList?.map((prod) => (
                    <Grid container key={prod.id} className={`extraProductRow`}>
                      <Grid item xs={3} className="extraProductCell vcDivider">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <EzControlledCheckBox
                            name={`extraProduct_${prod.id}`}
                            control={control}
                            value={selectedExtraProducts.includes(prod.id)}
                            onChange={() => handleExtraProductCheck(prod.id)}
                            customClassNames="extraProductCheckbox"
                          />
                          <span style={{ marginLeft: "3px" }}>
                            {prod.extraProductCharge}
                          </span>
                        </div>
                      </Grid>
                      <Grid item xs={3} className="extraProductCell vcDivider">
                        {prod.extraProductCategory}
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className="extraProductCell"
                        style={{ fontSize: "13px" }}
                      >
                        {prod.catTitle}
                      </Grid>
                    </Grid>
                  ))}
                </div>
              </div>
            )}

            {activeStep === 5 && (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>
                  <div className="policy-editor-wrap">
                    <EzControlledEditorFloatingLabel
                      name={"locationPolicy"}
                      control={control}
                      label={"Policy"}
                      rules={locationPolicyRules}
                      onChange={() => trigger("locationPolicy")}
                      isError={errors["locationPolicy"]}
                      errorMsg={null}
                    />
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "11px", marginTop: 0 }}>
                    <span>{getFormErrorMessage("locationPolicy")}</span>
                    <span style={{ color: (watch("locationPolicy")?.length || 0) > POLICY_MAX_LENGTH ? "red" : "#666" }}>
                      {(watch("locationPolicy")?.length || 0).toLocaleString()} / {POLICY_MAX_LENGTH.toLocaleString()}
                    </span>
                  </div>
                  <div style={{ margin: "15px 0px", maxWidth: "180px" }}>
                    <Button
                      onClick={policyBrakdownModal}
                      type="button"
                      width={"100px"}
                    >
                      Policy Breakdown
                    </Button>
                  </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <EzControlledInputAreaWithFloatingLabel
                    type="textarea"
                    name={"shuttleHours"}
                    control={control}
                    label={"Shuttle Hours"}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    isError={errors["shuttleHours"]}
                    errorMsg={getFormErrorMessage("shuttleHours")}
                  />
                </Grid>
              </Grid>
            )}
            {showDialog && (
              <EzDialog
                onHide={onDialogHide}
                maximizable={false}
                width={window.innerWidth <= 600 ? "100vw" : "70vw"}
                header={"Policy Breakdown"}
              >
                <Grid container spacing={2} paddingTop={"10px"}>
                  {policyBreakdownlist?.map((item) => {
                    const charCount = watch(item.name)?.length || 0;
                    return (
                      <Grid item xs={12} sm={6} md={4} key={item.name}>
                        <div className="breakdown-field-wrap">
                          <EzControlledInputAreaWithFloatingLabel
                            type="textarea"
                            name={item?.name}
                            control={control}
                            label={item?.label}
                            rules={breakdownFieldRules}
                            isError={errors[item?.name]}
                            errorMsg={null}
                            onChange={() => trigger(item.name)}
                          />
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "10px", marginBottom: "4px" }}>
                          <span>{getFormErrorMessage(item?.name)}</span>
                          <span style={{ color: charCount > BREAKDOWN_FIELD_MAX_LENGTH ? "red" : "#666" }}>
                            {charCount.toLocaleString()} / {BREAKDOWN_FIELD_MAX_LENGTH.toLocaleString()}
                          </span>
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
              </EzDialog>
            )}
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <div style={{ margin: "15px 10px", minWidth: "100px" }}>
                  <Button
                    color="inherit"
                    className="p-btn-danger p-button-outlined"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                </div>

                {completed ? (
                  <React.Fragment>
                    <div
                      style={{
                        margin: "15px 0px 15px 10px",
                        minWidth: "100px",
                      }}
                    >
                      <Button
                        type="submit"
                        label={isEdit ? "Update" : "Save"}
                        className="p-button-raised"
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button onClick={handleNext}>Next</Button>
                  </div>
                )}
              </div>
            </div>

            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateLocationComponent;
